<template>
  <div class="noticeSetting">
    <router-view :route-loading="loading"></router-view>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  name: 'NoticeSetting',
  data() {
    return {
      loading: false,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    ...mapActions('settings', []),
    async init() {
      try {
        this.loading = true;
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss">
.noticeSetting {
  height: 100%;
}
</style>
